export default {"src":"/_next/static/media/image-doc.1d810e24.svg","height":40,"width":40};